export interface InvoiceAccessModel {
  // General access section.
  canReadInvoices: boolean;
  canReadInvoiceById: boolean;
  canWriteInvoices: boolean;
  canRemoveTemplate: boolean;
  canSaveForce: boolean;
  canWriteReceiptOfInvoice: boolean;
  canReadReceiptOfInvoice: boolean;
}


export const INVOICE_ACCESS_DEFAULT: InvoiceAccessModel = {
  canReadInvoices: false,
  canReadInvoiceById: false,
  canWriteInvoices: false,
  canRemoveTemplate: false,
  canSaveForce: false,
  canWriteReceiptOfInvoice: false,
  canReadReceiptOfInvoice: false,
};
